import { remove } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { useMutation, type UseMutationOptions, useQueryClient } from "@tanstack/react-query";
import { z } from "zod";

import { createUseGetWorkerShoppableQualificationsQueryKey } from "./useGetWorkerShoppableQualifications";

interface DeleteWorkerShoppableQualificationParams {
  shoppableQualificationId: string;
}

export function useDeleteWorkerShoppableQualification(
  workerId: string,
  options: UseMutationOptions<void, unknown, DeleteWorkerShoppableQualificationParams> = {}
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data) => {
      const { shoppableQualificationId } = data;
      await remove({
        url: `${environmentConfig.REACT_APP_BASE_API_URL}/workers/${workerId}/shoppable-qualifications/${shoppableQualificationId}`,
        requestSchema: z.undefined(),
        responseSchema: z.unknown(),
      });
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      queryClient.invalidateQueries({
        queryKey: createUseGetWorkerShoppableQualificationsQueryKey(workerId),
      });
    },
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.DELETE_WORKER_SHOPPABLE_QUALIFICATION_FAILURE,
    },
    ...options,
  });
}
